import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=72088d21&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=js&"
export * from "./Contracts.vue?vue&type=script&lang=js&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=72088d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72088d21",
  null
  
)

export default component.exports